import { NOTES } from 'src/modules/constants';
import { Module, ModulesList } from 'src/modules/types';
import Notes from './index';
import NotesThunk from './thunk';

const module: ModulesList = {
  [NOTES]: {
    path: '/notes',
    component: Notes,
    thunk: NotesThunk,
  } as Module,
};

export default module;
